module.exports = __webpack_public_path__ + "img/wawa2-cover.609956d5.jpg";